import DailyFerryEdit from "@/controllers/daily_ferry/daily-ferry-edit.js";
import axios from 'axios';
import CONFIG from "@/assets/js/config.custom.js";

export default {
  extends: DailyFerryEdit,

  data() {
    return {
      ...DailyFerryEdit.data.call(this),
      teacherArr: [],
      updateScope: CONFIG.UPDATE_SCOPE.APPLY_TODAY_ONLY,
      CONFIG: CONFIG,
    };
  },

  methods: {
    ...DailyFerryEdit.methods,

    getTeacher() {
      axios.get('/teacher/getallTeacher', {
        params: {
          campus_id: this.$store.state.user.campus_id
        }
      })
        .then(res => {
          this.teacherArr = res.data[0];
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    update() {
      this.submitted = true;
      if ((this.pickupData != null && this.selectedPickups.length == 0) || this.selectedPickups.length == 0) {
        this.pointError = true;
      } else {
        this.pointError = false;
      }
      if (this.$v.$invalid || this.pointError == true) {
        return;
      }
      this.$bvModal.show('confirm-update-modal');
    },

    confirmUpdate() {
      this.$bvModal.hide('confirm-update-modal');
      this.disabled = true;
      this.DFData.loginId = this.$store.state.user.id;
      this.DFData.campus_id = this.$store.state.user.campus_id;
      this.DFData.pickup = this.selectedPickups;
      this.DFData.update_scope = this.updateScope;
      this.isLoading = true;
      axios.post(`dailyFerry/update/${this.$route.params.id}`, this.DFData)
        .then(res => {
          if (res.data.success == true) {
            this.$notification.success("Daily Ferry Updated Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({ name: "dailyFerryList" });
          } else {
            this.disabled = false;
            this.isLoading = false;
            this.$notification.error(res.data.message, {
              timer: 3,
              position: "bottomCenter",
            });
          }
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          if (error.response.status == 422) {
            const applyDateError = error.response.data?.errors?.apply_date?.[0];
            const message = applyDateError || error.response.data?.message;
            if (message) {
              this.$notification.error(message, {
                timer: 3,
                position: "bottomCenter",
              });
            }
          }
          this.disabled = false;
          this.isLoading = false;
        });
    },
  },

  mounted() {
    this.getTeacher();
  }
};
